import { MOBILE_MODE_WIDTH_THRESHOLD, SMALL_DESKTOP_WIDTH_THRESHOLD, TABLET_WIDTH_THRESHOLD } from './constant';

export const onSmallDesktopDown = (cssRules: string) => `
  @media (max-width: ${SMALL_DESKTOP_WIDTH_THRESHOLD - 1}px) {
    ${cssRules}
  }
`;

export const onTabletDown = (cssRules: string) => `
  @media (max-width: ${TABLET_WIDTH_THRESHOLD}px) {
    ${cssRules}
  }
`;

export const onDesktop = (cssRules: string) => `
  @media (min-width: ${MOBILE_MODE_WIDTH_THRESHOLD + 1}px) {
    ${cssRules}
  }
`;

export const onMobile = (cssRules: string) => `
  @media (max-width: ${MOBILE_MODE_WIDTH_THRESHOLD}px) {
    ${cssRules}
  }
`;

// Completely hide element that's applied with this on mobile mode
export const hideOnMobile = () => onMobile('display: none;');
